import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import type { NewsItem } from "@/types/content";

const allNews = news as NewsItem[];
const eveningList = allNews.filter((item) => item.isEvening).sort((a, b) => b.heat - a.heat);
const highlight = eveningList[0];
const rest = eveningList.slice(1);

export default function EveningHot() {
  return (
    <section id="evening" className="w-full scroll-mt-20 bg-foreground-900">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] uppercase text-accent-400">
              <span className="w-6 h-px bg-accent-400" />
              EVENING HOT
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold tracking-tight text-background-50">
              晚间热搜榜
            </h2>
            <p className="mt-3 text-sm md:text-base leading-7 text-background-300">
              每晚 20:00 之后热度变化最快。我们把当天讨论度最高的话题按热度排好序，一次性看完今天的重点。
            </p>
          </div>
          <Link
            to="/topics"
            className="inline-flex w-fit items-center gap-2 rounded-md border border-background-600/70 px-5 py-3 text-sm font-medium text-background-100 hover:border-accent-400 hover:text-accent-300 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看完整榜单
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </span>
          </Link>
        </div>

        {highlight && (
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-[1.1fr_1fr] gap-6 lg:gap-8">
            <article className="group relative overflow-hidden rounded-lg border border-background-700/60">
              <div className="w-full h-64 md:h-full md:min-h-[360px]">
                <img
                  src={highlight.image}
                  alt={`${highlight.title} 配图`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              <div className="absolute top-5 left-5 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-foreground-950">
                  01
                </span>
                <span className="rounded-full bg-primary-500 px-3 py-1 text-[11px] font-medium text-background-50">
                  沸
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <p className="text-xs text-background-200">
                  {highlight.category} · 热度 {highlight.heat} · {highlight.time}
                </p>
                <h3 className="mt-2 font-heading text-xl md:text-2xl font-bold leading-8 text-background-50">
                  <Link to={`/article/${highlight.id}`} className="hover:text-accent-300 transition-colors cursor-pointer">
                    {highlight.title}
                  </Link>
                </h3>
              </div>
            </article>

            <ol className="space-y-1.5">
              {rest.map((item, index) => (
                <li key={item.id}>
                  <Link
                    to={`/article/${item.id}`}
                    className="flex items-start gap-4 rounded-lg border border-background-700/50 px-4 py-4 hover:border-accent-500/70 hover:bg-background-800/60 transition-colors cursor-pointer"
                  >
                    <span className="mt-0.5 w-6 shrink-0 font-heading text-lg font-bold text-background-400">
                      {String(index + 2).padStart(2, "0")}
                    </span>
                    <span className="min-w-0">
                      <span className="block text-sm md:text-base leading-7 text-background-100 line-clamp-2">
                        {item.title}
                      </span>
                      <span className="mt-1.5 flex items-center gap-3 text-[11px] text-background-400">
                        <span>{item.category}</span>
                        <span className="inline-flex items-center gap-1">
                          <span className="w-3 h-3 flex items-center justify-center text-accent-400">
                            <i className="ri-fire-line" aria-hidden="true"></i>
                          </span>
                          {item.heat}
                        </span>
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        )}
      </div>
    </section>
  );
}